import {
  REQUEST,
  SUCCESS,
  FAILURE,
  SOCKET,
} from 'flaivy-react/reducers/action-type';
import { ACTION_TYPES } from '../actions/generated/order.actions';

const initialState = {
  loading: false,
  entity: {},
  error: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_ORDER):
    case REQUEST(ACTION_TYPES.CREATE_ORDER):
    case REQUEST(ACTION_TYPES.UPSERT_ORDER): {
      return {
        ...state,
        loading: true,
      };
    }
    case FAILURE(ACTION_TYPES.FETCH_ORDER_LIST):
    case FAILURE(ACTION_TYPES.FETCH_ORDER):
    case FAILURE(ACTION_TYPES.CREATE_ORDER):
    case FAILURE(ACTION_TYPES.UPSERT_ORDER): {
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    }
    case SUCCESS(ACTION_TYPES.FETCH_ORDER): {
      const entity = action.payload;
      return {
        ...state,
        entity,
        loading: false,
      };
    }
    case SOCKET('ORDER_DELIVERY_DATE_CHANGED'):
    case SOCKET('ORDER_WAITING_FOR_RESTOCK'):
    case SOCKET('ORDER_OFC_CHANGED'):
    case SOCKET('ORDER_WAREHOUSE_PROCESSING_STARTED'):
    case SOCKET('ORDER_APPROVED_BY_DROPSHIPSUPPLIER'):
    case SOCKET('ORDER_APPROVED'):
    case SOCKET('ORDER_PLACED'):
    case SOCKET('ORDER_DELIVERED'):
    case SOCKET('ORDER_INVOICED'):
    case SOCKET('ORDER_READY_FOR_SHIPPING'):
    case SOCKET('ORDER_SENT'):
    case SOCKET('ORDER_RECEIVED'):
    case SOCKET('ORDER_CANCELLED'):
    case SOCKET('ORDER_UPDATED'):
    case SOCKET('ORDER_ADVANCE_PAYMENT_RECEIVED'):
    case SOCKET('ORDER_MERGED'):
    case SOCKET('ORDER_CONNECTED_TO_SUPPLIER_CUSTOMER'):
    case SOCKET('ORDER_CREATED'): {
      const { fullEntity } = action.payload;
      if (fullEntity.id === state.entity.id) {
        return {
          ...state,
          entity: fullEntity,
        };
      } else {
        return state;
      }
    }
    default:
      return state;
  }
};

export default reducer;
